import React from "react";
import { DropdownButton } from "react-bootstrap";
import { FilterOption } from "common/ui/components/table/FilterOption";
//--
export class FilterDropdown extends React.Component {
    constructor(props) {
        super(props);
    }
    renderItems() {
        let { filters, clickCallback } = this.props;
        return filters.map((filter, index) => (React.createElement(FilterOption, { key: index, keyName: filter.keyName, filterCallback: () => clickCallback(filter.id), displayName: filter.displayName })));
    }
    render() {
        return (React.createElement(DropdownButton, { title: this.props.selection, id: `Dropdown_${this.props.keyName}`, bsSize: "small", onClick: (e) => e.stopPropagation() }, this.renderItems()));
    }
}
